var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "main setting" },
    [
      _c("popup", {
        attrs: {
          opened: _vm.openData,
          "use-header": true,
          "use-footer": true,
          "btn-area-padding": true
        },
        on: {
          "update:opened": function($event) {
            _vm.openData = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "setting-tit" },
                  [
                    _vm.step == 1
                      ? [
                          _c("span", [
                            _vm._v(" Choose "),
                            _c("br"),
                            _vm._v("your ")
                          ]),
                          _vm._v("country ")
                        ]
                      : [
                          _c("span", [
                            _vm._v(" Choose "),
                            _c("br"),
                            _vm._v("your ")
                          ]),
                          _vm._v("language ")
                        ]
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "form-check-group --type3 right" },
                  [
                    _vm.step == 1
                      ? [
                          _c("div", { staticClass: "form-row" }, [
                            _c("div", { staticClass: "form-check" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedSiteCodeData,
                                    expression: "selectedSiteCodeData"
                                  }
                                ],
                                staticClass: "form-check-input",
                                attrs: {
                                  type: "radio",
                                  id: "siteCode_" + _vm.$config.SITECODE_OGMMR,
                                  name: "siteCode"
                                },
                                domProps: {
                                  value: _vm.$config.SITECODE_OGMMR,
                                  checked: _vm._q(
                                    _vm.selectedSiteCodeData,
                                    _vm.$config.SITECODE_OGMMR
                                  )
                                },
                                on: {
                                  change: function($event) {
                                    _vm.selectedSiteCodeData =
                                      _vm.$config.SITECODE_OGMMR
                                  }
                                }
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "form-check-label",
                                  attrs: {
                                    for:
                                      "siteCode_" + _vm.$config.SITECODE_OGMMR
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon icon-nation-mm"
                                  }),
                                  _vm._v(" Myanmar ")
                                ]
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "form-row" }, [
                            _c("div", { staticClass: "form-check" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedSiteCodeData,
                                    expression: "selectedSiteCodeData"
                                  }
                                ],
                                staticClass: "form-check-input",
                                attrs: {
                                  type: "radio",
                                  id: "siteCode_" + _vm.$config.SITECODE_OGHCM,
                                  name: "siteCode"
                                },
                                domProps: {
                                  value: _vm.$config.SITECODE_OGHCM,
                                  checked: _vm._q(
                                    _vm.selectedSiteCodeData,
                                    _vm.$config.SITECODE_OGHCM
                                  )
                                },
                                on: {
                                  change: function($event) {
                                    _vm.selectedSiteCodeData =
                                      _vm.$config.SITECODE_OGHCM
                                  }
                                }
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "form-check-label",
                                  attrs: {
                                    for:
                                      "siteCode_" + _vm.$config.SITECODE_OGHCM
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon icon-nation-vn"
                                  }),
                                  _vm._v(" Vietnam ")
                                ]
                              )
                            ])
                          ])
                        ]
                      : _vm._l(_vm.siteLangList, function(data, i) {
                          return _c(
                            "div",
                            { key: i, staticClass: "form-row" },
                            [
                              _c("div", { staticClass: "form-check" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedLangCode,
                                      expression: "selectedLangCode"
                                    }
                                  ],
                                  staticClass: "form-check-input",
                                  attrs: {
                                    type: "radio",
                                    id: "lang_" + data.lang,
                                    name: "lang"
                                  },
                                  domProps: {
                                    value: data.lang,
                                    checked: _vm._q(
                                      _vm.selectedLangCode,
                                      data.lang
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.selectedLangCode = data.lang
                                    }
                                  }
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "form-check-label",
                                    attrs: { for: "lang_" + data.lang }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon",
                                      class: "icon-nation-" + data.icon
                                    }),
                                    _vm._v(" " + _vm._s(data.text) + " ")
                                  ]
                                )
                              ])
                            ]
                          )
                        })
                  ],
                  2
                )
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _vm.step == 1
                  ? [
                      _c(
                        "button",
                        {
                          staticClass: "btn md normal",
                          on: { click: _vm.selectedCtr }
                        },
                        [_vm._v(_vm._s(/*다음*/ _vm.$t("MCOM-0000034")))]
                      )
                    ]
                  : [
                      _c(
                        "button",
                        {
                          staticClass: "btn md gray",
                          on: { click: _vm.goPrev }
                        },
                        [_vm._v(_vm._s(/*이전*/ _vm.$t("MCOM-0000033")))]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn md normal",
                          on: { click: _vm.selectedLang }
                        },
                        [_vm._v(_vm._s(/*완료*/ _vm.$t("MCOM-0000106")))]
                      )
                    ]
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("update-popup", { ref: "versionUpdate" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }